document.addEventListener("DOMContentLoaded", function () {
  //truncate title on mobile device
  const truncateTitle = () => {
    document
      .querySelectorAll(".product-card .product-card__title")
      .forEach((item) => {
        if (!item.dataset.originalText) {
          item.dataset.originalText = item.textContent; // Store original title only once
        }

        const originalText = item.dataset.originalText;

        if (window.matchMedia("(max-width: 550px)").matches) {
          if (
            originalText.includes("Precision") &&
            originalText.includes("-")
          ) {
            item.textContent = originalText.split("-")[1].trim(); // Truncate
          }
        } else {
          item.textContent = originalText; // Restore full title
        }
      });
  };

  truncateTitle(); // Run on load
  window.addEventListener("resize", truncateTitle); // Run on resize

  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header-section");
    const headerHeight = header.offsetHeight;
    const scrollPosition = window.scrollY;

    if (scrollPosition > headerHeight) {
      header.classList.add("is-fixed");
    } else {
      header.classList.remove("is-fixed");
    }
  });

  const documentBody = document.querySelector("body");

  function checkBrowser() {
    let browserName = "";

    if (navigator.vendor.match(/google/i)) {
      documentBody.classList.add("chrome");
    } else if (navigator.vendor.match(/apple/i)) {
      documentBody.classList.add("safari");
    }
  }

  checkBrowser();

  // TO CLOSE THE FILTER FACETS
  const filterFacets = document.querySelector("#FacetDrawerSticky");
  const closeFacetBtn = document.querySelector("#close-facet");

  if (filterFacets) {
    closeFacetBtn.addEventListener("click", function () {
      filterFacets.removeAttribute("open");
      filterFacets.removeAttribute("active");
    });
  }

  // PRODUCT PAGE LEAD TIME SCRIPT
  // const productName = document.querySelector(
  //   ".product-page-cs #flag-input"
  // ).value;
  // const elementToAppend = `
  //           <div class="additional-information">
  //               <p>
  //                 <span>Current Lead Time: </span> 4 weeks
  //               </p>

  //                <p>
  //                 <span>Don't see your vehicle listed or need multiple vehicles? </span> <a href="/pages/contact">Contact Us</a>
  //               </p>
  //           </div>`;
  // const formWrapper = document.querySelector(
  //   ".product-form-wrapper .product-form__buttons"
  // );
  // if (formWrapper) {
  //   if (productName.includes("precision")) {
  //     formWrapper.insertAdjacentHTML("beforebegin", elementToAppend);
  //   }
  // }
});
